import React from "react";

/**
 * Phase 24 polish — the tinted icon circle/square used at the top of cards
 * and steps. Previously drawn ad hoc in six sizes and three colour schemes.
 *
 *   size: "sm" (h-9)  | "md" (h-11, default) | "lg" (h-12)
 *   tone: "blue" (default) | "orange" | "plain" (white with border)
 */
const SIZES = {
  sm: { box: "h-9 w-9", icon: "h-4 w-4" },
  md: { box: "h-11 w-11", icon: "h-5 w-5" },
  lg: { box: "h-12 w-12", icon: "h-5 w-5" },
};

const TONES = {
  blue: "bg-brand-blue-tint text-brand-blue",
  orange: "bg-brand-orange-tint text-brand-orange",
  plain: "bg-white border border-border text-brand-orange",
};

export const IconBadge = ({ icon: Icon, size = "md", tone = "blue", className = "", ...rest }) => {
  const sz = SIZES[size] || SIZES.md;
  return (
    <span
      className={`inline-grid place-items-center rounded-xl shrink-0 ${sz.box} ${TONES[tone] || TONES.blue} ${className}`}
      aria-hidden="true"
      {...rest}
    >
      {Icon && <Icon className={sz.icon} strokeWidth={1.5} />}
    </span>
  );
};

export default IconBadge;
